<template>
  <div class="body">
 hhhhhhhhhhhhhhhh
  </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  created() {},
  mounted() {
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
@import "../assets/sass/global.scss";
</style>
<style lang="scss" scoped>
.body {
  //   background: #fff;
  //   min-height: 100vh;
  //   box-sizing: border-box;
  // //   position: relative;
  // //   overflow: auto;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.bgc {
  text-align: left;
  margin-left: 18px;
  width: 340px;
  height: 147px;
  background: url("../assets/img/fail_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .p {
    padding-top: 27px;
    margin-left: 33px;
    margin-right: 33px;
  }
  .pp {
    margin-left: 33px;
    margin-right: 33px;
  }
}
h3 {
  font-size: 17px;
  color: #373737;
  margin-bottom: 39px;
}
.boximg {
  margin-top: 121px;
  margin-left: 147px;
  margin-bottom: 20px;
  width: 83px;
  img {
    width: 100%;
    height: auto;
  }
}
</style>
<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/VipServiceAgreement.vue